import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBImportType, DBImportSource, DBImportFieldMapping, DBRecurringImport, DBRecurringFormat } from '../../types/import';
import { EndpointResponse } from '../../types/endpoints';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

const validate = (name: string, importType: string, source: DBImportSource) => {
  if (!name) {
    throw new Error('Name is required');
  }
  if (!importType) {
    throw new Error('Import type is required');
  }
  if (!source) {
    throw new Error('Source is required');
  }
};

type RequestParams = {
  name: string;
  importType: DBImportType;
  format?: DBRecurringFormat;
  source: DBImportSource;
  fieldMappings?: DBImportFieldMapping[];
};

type Response = DBRecurringImport;

export const createRecurringImport = async (
  scope: RequestScope,
  { name, importType, format, source, fieldMappings }: RequestParams,
  requestOptions: WriteRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(name, importType, source);

    const importProfile = {
      name,
      import_type: importType,
      ...(format !== undefined && { format }),
      source: {
        type: source.type,
        host: source.host,
        port: source.port,
        username: source.username,
        password: source.password,
        frequency: source.frequency,
        glob: source.glob,
      },
      ...(fieldMappings && {
        field_mapping: fieldMappings.map((mapping) => ({
          type: mapping.type,
          identifier_match: mapping.identifier_match,
          rule: mapping.rule,
          source_field: mapping.source_field,
          value: mapping.value,
          acenda_field: mapping.acenda_field,
        })),
      }),
    };
    const response = await scopedApi(scope).post<EndpointResponse<Response>>('/recurring_import', importProfile, requestOptions);

    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
